import type { FaireProductEntity } from "../../entity_types/product";

export const p_zt92rzmb6v: FaireProductEntity = {
  token: "p_zt92rzmb6v",
  type: "product",
  name: "Unisex EVIL EYE HAMSA Printed Eye Glass Case",
  brandToken: "b_eungak2r99",
  brandName: "Nima Accessories Inc",
  imageUrl: "https://cdn.faire.com/fastly/9b7eff0ef1cf25407da93390c0b18508812e671bbb348fb5d3d69d3dbd19ea24.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.77,
  description: "Presenting the Unisex EVIL EYE HAMSA Printed Eye Glass Case from Nima Accessories Inc., a leader in women's accessories since 1982. This eye glass case is a perfect blend of functionality and fashion. It's not just an accessory, but a statement piece that reflects your unique style. Protect your eyewear with our case, designed to ensure durability and safety for your glasses. Experience why Nima Accessories is known as the \"one stop accessory store\", offering the newest and most fashion-forward accessories every season.",
  tags: [],
  msrpDollars: 5.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:23.894Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
